import { Component, Input } from '@angular/core';

@Component({
    selector: 'tvcore-appendix',
    templateUrl: './appendix.component.html',
    styleUrls: ['./appendix.component.scss'],
    standalone: false
})
export class AppendixComponent {
	@Input()
	url: string;
}
